<template>
    <Frame>
        <PageHeader :title="$t('UrgentQuery.title')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">
                <div class="filter-contain" style="width: 35%;">
                    <span style="min-width: 70px;">{{ $t('UrgentQuery.X_FillDate') }}</span>
                    <el-date-picker v-model="rangeDate" type="daterange" size="small" range-separator="~"
                        :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
                        :picker-options="PickerOptions" :unlink-panels="true" @change="changeTime()"></el-date-picker>
                </div>

                <div class="filter-contain">
                    <span style="min-width: 98px;">{{ $t('UrgentQuery.BillNo') }}</span>
                    <el-input v-model="BillNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('UrgentQuery.customerNoLab') }}</span>
                    <el-input v-model="customerPayNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain" style="width: 35%;">
                    <span style="min-width: 70px;">OR：</span>
                    <el-input v-model="Or" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span style="min-width: 98px;">{{ $t('UrgentQuery.urgentDealStateName') }}</span>
                    <el-select size="small" v-model="urgentDealState">
                        <el-option v-for="item in urgentDealStateList" :key="item.value" :label="item.label"
                            :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </div>

                <div style="width:31%;"> 
                    <span style="width: 100%;display: flex; justify-content: flex-end;">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
                    </span>
                </div>
            </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
            v-loading="tableLoading">
            <el-table-column type="index" width="50" :label="$t('orderImport.rowNo')"></el-table-column>
            <el-table-column :width="WidthControl('X_SupId', tableData)" prop="X_SupId" :label="$t('salSalesOrder.supplier')"></el-table-column>
            <el-table-column :width="WidthControl('X_TotalSQty', tableData,4)" prop="X_TotalSQty" :label="$t('salSalesOrder.sQty')"></el-table-column>
            <el-table-column :min-width="WidthControl('BillDate', tableData)" prop="BillDate" :label="$t('salSalesOrderDetail.messagedate')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_NewDate', tableData)" prop="X_NewDate" :label="$t('salSalesOrder.newDate2')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_PreDate', tableData)" prop="X_PreDate":label="$t('salSalesOrder.preDate')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_CustNumberOrg', tableData)" prop="X_CustNumberOrg" :label="$t('salSalesOrder.customerNo2')"></el-table-column>
            <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo" :label="$t('salSalesOrder.orderNo')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_Or', tableData)" prop="X_Or" label="OR"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialId', tableData)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialName', tableData)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
            <el-table-column :min-width="WidthControl('X_FillDate', tableData)" prop="X_FillDate":label="$t('UrgentQuery.fillDate')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_UrgentDate', tableData)" prop="X_UrgentDate" :label="$t('salSalesOrder.hopeDate')"></el-table-column>
            <el-table-column width="140" prop="X_PredictDelDate" :label="$t('UrgentQuery.X_PredictDelDate')"></el-table-column>
            <el-table-column width="110" prop="X_UrgentDealState" :label="$t('salSalesOrder.urgentDealStateName')"></el-table-column>
        </el-table>
        <div class="footer-contain">
            <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
            <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
                layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage"
                :total="totalCount" :page-size="pageSize"></el-pagination>
        </div>
    </Frame>
</template>
<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { datePickerOptions, handleShortDate } from "@/utils/handleDate";
export default {
    name: "UrgentQuery",
    mixins: [listMixin],
    data() {
        return {
            PickerOptions: datePickerOptions(this),
            customerPayNo: "",
            tableHeight: window.innerHeight - 310,
            pagecount: 5,
            Or: "",
            urgentDealState: 0,
            urgentDealStateList: [
                { value: 0, label: this.$t("UrgentQuery.urgentDealState0") },
                { value: 1, label: this.$t("UrgentQuery.urgentDealState1") },
                { value: 2, label: this.$t("UrgentQuery.urgentDealState2") },
                { value: 3, label: this.$t("UrgentQuery.urgentDealState3") }
            ]
        };
    },
    props: {
        GetListData: {
            type: Function,
            default: function (pageIndex, ...arg) {
                this.getListData(pageIndex, ...arg);
            }
        }
    },
    mounted() {
        this.frameOnResize(310);
    },
    created() {
        this.rangeDate = this.getMonthRange();
        this.startDate = handleShortDate(this.rangeDate[0], "From");
        this.endDate = handleShortDate(this.rangeDate[1], "To");
        this.getListData(0)
    },
    methods: {
        getMonthRange() {
            const today = new Date();
            const curYear = today.getFullYear();
            const curMonth = today.getMonth();
            const startMonth = new Date(curYear, curMonth, 1);
            startMonth.setHours(0, 0, 0, 0);
            const endMonth = new Date(curYear, curMonth + 1, 0);
            endMonth.setHours(0, 0, 0, 0);
            return [startMonth, endMonth];
        },
        getListData(index) {
            this.pageIndex = index;
            this.tableLoading = true;
            this.axiosInvoke(
                this.sysHandlerUrl,
                {
                    action: "geturgentquery",
                    BillNo: this.BillNo,
                    urgentDealState: this.urgentDealState,
                    customerPayNo: this.customerPayNo,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    Or:this.Or,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                },
                res => {
                    const data = res.data;
                    this.tableLoading = false;
                    this.tableData = data.DataTable;
                    this.totalCount = data.totalCount;
                },
                false,
                true
            );
        },
        changeTime() {
            this.getTime();
            //this.GetListData(0);
        },
        reset() {
            this.baseReset();
            this.customerPayNo = "";
            this.Or = "";
            this.urgentDealState = 0;
            this.GetListData(0);
        },
        pageSizeChange() {
            this.GetListData(0);
        },
        handleCurrentChange(page) {
            this.pageIndex = page - 1;
            this.GetListData(this.pageIndex);
        }
    }
};
</script>
<style scoped>
.list-contain {
    display: flex;
    padding: 10px 0px;
}

.head-contain {
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.el-select {
    width: 100%;
}

.filter-contain {
    width: 31%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10px;
}
.filter-contain>span {
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
.el-table{
  font-size: 12px;
  color: black;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
    padding-left: 5px;
}

.footer-contain {
    display: flex;
    padding-top: 6px;
    justify-content: center;
}

.pagination {
    padding-top: 4px;
}

.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: black;
}
</style>
